import { adminStore } from '$lib/stores/admin';
import { apiStore } from '$lib/stores/api';
import type { Axios } from 'axios';
import { get, writable } from 'svelte/store';

export enum features {
	Ghost = 'ghost',
	Giftcards = 'giftcards',
	OnlineGiftcards = 'giftcards-online',
	Payment = 'payment',
	MultiActivity = 'multi-activity'
}

const featureFlipStoreDefinition = () => {
	const { subscribe, set, update } = writable({ features: [] as string[] });
	const refresh = () => {
		(get(apiStore) as Axios).get<features[]>('/feature-flipping').then((response) => {
			refreshFromData(response.data);
		});
	};
	const refreshFromData = (data: features[]) => {
		set({
			// {} => [] or ["feature1", "feature2", "feature3"]
			features: data.length === undefined ? [] : data
		});
	};
	const flipFeature = (name: features, forceSave = false) => {
		update((store) => {
			const value = !store.features.includes(name);
			if (value) {
				store.features.push(name);
			} else {
				store.features = store.features.filter((feature) => feature !== name);
			}
			// Save to the server
			if (
				!get(adminStore) ||
				(store.features.includes('ghost') && name != 'ghost') ||
				forceSave
			) {
				(get(apiStore) as Axios).post('/feature-flipping', [{ name: name, value: value }]);
			}
			return store;
		});
	};
	return {
		subscribe,
		set,
		update,
		flipFeature,
		refresh,
		refreshFromData
	};
};

export const featureFlipStore = featureFlipStoreDefinition();
